import React from "react";

import AddIcon from "@material-ui/icons/Add";
import { useHistory, useRouteMatch } from "react-router-dom";

import RbActions from "components/RbActions";
import RbButtonAction from "components/RbButtonAction";
import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";

import BasicForm from "./BasicForm";
import BasicList from "./BasicList";
import BasicMenu from "./BasicMenu";

function BasicDesktop() {
  const history = useHistory();
  const { path } = useRouteMatch();
  const match = useRouteMatch(`${path}/:type/:id?`);
  const type = match?.params?.type;

  const handleBack = () => {
    history.push("/examples");
  };

  const handleNew = () => {
    history.push(`${path}/${type}/new`);
  };

  return (
    <RbFlexView>
      <RbFlexViewItem bgcolor="custom.high">
        <RbHeader
          title="Basic"
          onBack={handleBack}
          actions={
            <RbActions>
              <RbButtonAction
                Icon={AddIcon}
                onClick={handleNew}
                disabled={!type}
                text="New"
              />
            </RbActions>
          }
        />
      </RbFlexViewItem>
      <RbFlexViewItem bgcolor="custom.bg.100" flex="1">
        <RbFlexView direction="row">
          <RbFlexViewItem bgcolor="custom.bg.200" flex="0 18%">
            <BasicMenu />
          </RbFlexViewItem>
          <RbFlexViewItem flex="1">
            <BasicList path={path} />
          </RbFlexViewItem>
          <RbFlexViewItem
            flex="0 28%"
            borderColor="custom.border.200"
            borderLeft={1}
          >
            <BasicForm path={path} />
          </RbFlexViewItem>
        </RbFlexView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

export default React.memo(BasicDesktop);
